module.exports = __webpack_public_path__ + "img/youth_at_rally_with_sign.31983ae5.jpg";